import { Map } from 'immutable';
import React from 'react';
import { DatePicker, Form, Icon, message } from 'antd';
import moment from 'moment';
import { Auth } from 'aws-amplify';
import PhoneInput from 'react-phone-number-input';
import Input,{ Textarea } from '../components/uielements/input';
import Select, { SelectOption } from '../components/uielements/select';
import Upload from '../components/uielements/upload';
import 'react-phone-number-input/style.css';
import { store } from '../redux/store';
import StateDD from '../containers/Widgets/StateDD';

const Option = SelectOption;

export function clearToken() {
  localStorage.clear();
}

export async function getToken() {
  try {
    const session = localStorage.getItem('isLoggedin');
    if (!session) {
      clearToken();
      return new Map();
    }

    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    // SWITCH LINE 31 WITH 32 TO SAVE API CALLS TO BACKEND DURING DEVELOPMENT
    const {
      'custom:isOnTrial': isOnTrial,
      'custom:subscriptionDue': subscriptionDue,
      'custom:customerId': customerId,
      'cognito:groups': groups,
      'cognito:username': username,
    } = user.signInUserSession.idToken.payload;
    // const { data: { getTherapist: { isOnTrial, subscriptionDue, customerId } } } = await API.graphql(graphqlOperation(GetSubscriptionDue));

    store.dispatch({ type: 'SET_PROVIDER', payload: username });
    store.dispatch({ type: 'SET_COGNITO_GROUPS', payload: groups });
    store.dispatch({ type: 'SET_PREMIUM_STATUS', subscriptionDue, isOnTrial, customerId });
    const mfaOption = await Auth.getPreferredMFA(user);
    if (mfaOption == 'SOFTWARE_TOKEN_MFA' || mfaOption == 'SMS_MFA') {
      const { idToken } = await Auth.currentSession();
      return new Map({ idToken });
    }
    clearToken();
    window.location.reload(true);
    return new Map();
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = number => {
    return number > 1 ? 's' : '';
  };
  const number = num => (num > 9 ? '' + num : '0' + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      }
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      const month = months[givenTime.getUTCMonth()];
      const day = number(givenTime.getUTCDate());
      return `${day} ${month}`;
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}

export const dataList={
  line1:"Line 1",
  city:"City",
  state:"State",
  zip:"Zip",
  type:'Provider Type',
  phone:"Phone number",
  dob:"Date of birth",
  first:"First name",
  last:"Last name",
  gender:"Gender",
  taxId:"Tax Id",
  street:"Street",
  firstName:"First name",
  lastName:"Last name",
  taxonomyCode:"Taxonomy code",
  npi:"NPI",
  practiceName:"Organization name",
  practiceDetailName:"Practice Details",
};

export const clientClaimData={
  line1:true,
  city:true,
  state:true,
  zip:true,
  phone:true,
  dob:true,
  first:true,
  last:true,
  gender:true,
};

export const providerClaimData={
  phone:true,
  type:true,
  taxId:true,
  street:true,
  state:true,
  zip:true,
  city:true,
  firstName:true,
  lastName:true,
  taxonomyCode:true,
  npi:true,
  practiceName:true,
};

export class FormField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Imageloading: false,
    };
  }

  /* ---------------------------- Image uploader helper functions -------------------------------- */
  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  beforeUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    if (!isJPG) {
      window.notify({
        type: 'error',
        message: 'You can only upload JPG file!',
        icon: 'info-sign',
      });
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      window.notify({
        type: 'error',
        message: 'Image must smaller than 2MB!',
        icon: 'info-sign',
      });
    }
    return isJPG && isLt2M;
  }

  handleImageChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      this.getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        }),
      );
    }
  };

  /* ---------------------------- Image uploader helper functions -------------------------------- */
  titleCase = value => {
    value = value.split('');
    value[0] = value[0].toUpperCase();
    return value.join('');
  };

  onChange = e => {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  render() {
    const { props } = this;
    const field = props.fieldAttribute;
    const type = field.type || 'input';
    const { icon } = field;
    const title = this.titleCase(field.name);
    const fieldLayout = props.formLayout; // 'vertical or horizontal'
    const label = field.namess || this.titleCase(field.name);
    const { getFieldDecorator } = props.form;
    const prefix = icon ? <Icon type={icon} style={{ color: 'rgba(0,0,0,.25)' }} /> : null;

    /* ---------------------------- Image -------------------------------- */
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className='ant-upload-text'>Upload</div>
      </div>
    );

    const { imageUrl } = this.state;

    /* ---------------------------- Image -------------------------------- */

    const Types = {
      textarea: () => {
        return (
          <Textarea
            className='bt_portal-input'
            style={{ width: '100%' }}
            placeholder={!props.disabled ? title : ''}
            prefix={prefix}
            disabled={props.disabled}
          />
        );
      },
      input: () => {
        return (
          <Input
            className='bt_portal-input'
            placeholder={!props.disabled ? title : ''}
            prefix={prefix}
            disabled={props.disabled}
          />
        );
      },
      select: () => {
        const { options } = field;
        return (
          <Select
            placeholder={!props.disabled ? title : ''}
            disabled={props.disabled}
            className='bt_portal-select'
            onChange={this.onChange}
          >
            {options.map((option, index) => (
              <Option key={index} value={option.value}>
                {option.name}
              </Option>
            ))}
          </Select>
        );
      },
      stateDD: () => {
        return (
          <StateDD
            placeholder={!props.disabled ? title : ''}
            disabled={props.disabled}
            onChange={this.onChange}
            className={"bt_portal-select"}
          />
        );
      },
      image: () => {
        return (
          <Upload
            name='avatar'
            listType='picture-card'
            className='avatar-uploader'
            showUploadList={false}
            action=''
            beforeUpload={this.beforeUpload}
            onChange={this.handleImageChange}
            disabled={props.disabled}
          >
            {imageUrl ? <img src={imageUrl} alt='' /> : uploadButton}
          </Upload>
        );
      },
      dob: () => (
        <DatePicker
          className='bt_portal-date_picker'
          disabled={props.disabled}
          format='MM/DD/YYYY'
        />
      ),
      phone: () => {
        return (
          <PhoneInput
            country='US'
            className='ant-input'
            placeholder='Enter phone number'
            displayInitialValueAsLocalNumber
            // value={ this.state.phone }
            // onChange={ phone => {this.setState({ phone }), this.inputs.phone = this.state.phone} }
            disabled={props.disabled}
            style={
              props.disabled
                ? {
                    padding: '0px',
                    border: 'none',
                    color: 'black',    margin: '0 5px',
              width: 'calc(100% - 10px)',
                    background: 'transparent',
                  }
                : null
            }
          />
        );
      },
    };
    const formItemLayout =
      fieldLayout === 'vertical'
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 24 },
              md: { span: 24 },
              lg: { span: 24 },
              wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
                md: { span: 24 },
                lg: { span: 24 },
              },
            },
          }
        : {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 12 },
              md: { span: 7 },
              lg: { span: 7 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 12 },
              md: { span: 17 },
              lg: { span: 17 },
            },
          };
    const fixedLayout =
      fieldLayout === 'vertical'
        ? {
            labelCol: {
              span: 24,
            },
            wrapperCol: {
              span: 24,
            },
          }
        : {
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          };

    /* const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    }; */
    return (
      <Form.Item
        className={field.name + ' bt_portal-form_item'}
        label={label}
        help={field.help}
        format='MM/DD/YYYY'
        labelAlign='left'
        hideRequiredMark
        {...fixedLayout}
        colon={props.disabled}
      >
        {getFieldDecorator(field.name, {
          rules: field.validation,
          initialValue:
            type === 'dob' && field.default ? moment(field.default): field.default || null,
        })(Types[type]())}

      </Form.Item>
    );
  }
}
